import axiosInstance from "@/lib/axios";

import {
  AskRequest,
  AskResponse,
  ChatDetail,
  ChatListItem,
  MessageStatusResponse,
  PaginatedResponse,
} from "../types/chat";

export const yetakchiAiAPI = {
  ask: async (data: AskRequest): Promise<AskResponse> => {
    const response = await axiosInstance.post<AskResponse>(
      "yetakchi-ai/ask/",
      data,
    );
    return response.data;
  },

  getMessageStatus: async (
    messageUuid: string,
  ): Promise<MessageStatusResponse> => {
    const response = await axiosInstance.get<MessageStatusResponse>(
      `yetakchi-ai/messages/${messageUuid}/status/`,
    );
    return response.data;
  },

  getChats: async (): Promise<ChatListItem[]> => {
    const response =
      await axiosInstance.get<PaginatedResponse<ChatListItem>>(
        "yetakchi-ai/chats/",
      );
    return response.data.results;
  },

  getChatDetail: async (chatUuid: string): Promise<ChatDetail> => {
    const response = await axiosInstance.get<ChatDetail>(
      `yetakchi-ai/chats/${chatUuid}/`,
    );
    return response.data;
  },

  archiveChat: async (chatUuid: string): Promise<void> => {
    await axiosInstance.post(`yetakchi-ai/chats/${chatUuid}/archive/`);
  },
};
